import {Criterion} from "../HealthcareUsageReport/types/CohortQuery";
import React, {useState} from "react";
import styles from "./CohortSummary.module.scss";
import {CaretDownOutlined, CaretUpOutlined} from "@ant-design/icons";

const CriterionDescription = ({ criterion }: { criterion: Criterion }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const maxCharLimit = 400;

    if (!criterion.description) {
        return null;
    }

    const toggleExpand = () => setIsExpanded(!isExpanded);
    const fullDescription = criterion.description;
    const displayDescription =
        fullDescription.length > maxCharLimit && !isExpanded
            ? `${fullDescription.slice(0, maxCharLimit)}...`
            : fullDescription;

    return (
            <div className={styles['filters']}>
                <span dangerouslySetInnerHTML={{ __html: displayDescription }} />
                {fullDescription.length > maxCharLimit && (
                    isExpanded ? (
                        <button
                            data-testid="collapse-button"
                            className={styles.titleButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpand();
                            }}
                        >
                            <CaretUpOutlined data-testid='caret-up' className={styles.icon} />
                        </button>
                    ) : (
                        <button
                            data-testid="expand-button"
                            className={styles.titleButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpand();
                            }}
                        >
                            <CaretDownOutlined data-testid='caret-down' className={styles.icon} />
                        </button>
                    )
                )}
            </div>
    );


};

export default CriterionDescription;